// 粘性购物车变体切换逻辑
// 只更新粘性购物车自身的主图、价格、选中状态、隐藏域

document.addEventListener('DOMContentLoaded', function () {
    // 获取变体数据
    var variants = [];
    var variantsScript = document.getElementById('StickyCartBarVariants');
    if (variantsScript) {
        try {
            variants = JSON.parse(variantsScript.textContent);
        } catch (e) { }
    }

    // 获取粘性购物车 DOM
    var stickyBar = document.getElementById('sticky-cart-bar');
    if (!stickyBar) return;

    // 1. 监听移动端颜色 swatch
    var colorSwatches = stickyBar.querySelectorAll('.color-swatch');
    colorSwatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var variantId = btn.dataset.variantId;
            if (!variantId) return;

            // 更新选中状态
            colorSwatches.forEach(function (b) { b.classList.remove('selected'); });
            btn.classList.add('selected');

            // 查找变体数据
            var variant = variants.find(function (v) { return v.id == variantId || v.id == Number(variantId); });
            if (!variant) return;

            // 更新主图
            var img = stickyBar.querySelector('.sticky-cart-bar__mobile-info .product-info img');
            if (img) {
                if (variant.featured_image) {
                    img.src = typeof variant.featured_image === 'string'
                        ? variant.featured_image
                        : (variant.featured_image.src || '');
                } else if (window.__StickyCartBarMainImage) {
                    img.src = window.__StickyCartBarMainImage;
                }
            }

            // 更新价格
            var priceBox = stickyBar.querySelector('.sticky-cart-bar__mobile-info .product-price');
            if (priceBox) {
                var html = '';
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    html += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
                }
                html += '<strong>' + formatMoney(variant.price) + '</strong>';
                priceBox.innerHTML = html;
            }

            // 更新移动端弹框隐藏域
            var atcInputMobile = stickyBar.querySelector('.sticky-cart-bar__mobile-info input[name="id"]');
            if (atcInputMobile) {
                atcInputMobile.value = variantId;
            }

            // 更新选中颜色文本
            var selectedColor = stickyBar.querySelector('.selected-color');
            if (selectedColor && variant.option1) {
                selectedColor.textContent = variant.option1;
            }
        });
    });

    // 2. 监听桌面端 select
    var selector = stickyBar.querySelector('.variant-selector');
    if (selector) {
        selector.addEventListener('change', function () {
            var variantId = selector.value;
            if (!variantId) return;
            
            // 查找变体数据
            var variant = variants.find(function (v) { return v.id == variantId || v.id == Number(variantId); });
            if (!variant) return;

            // 更新主图
            var img = stickyBar.querySelector('.sticky-cart-bar__desktop .product-info img');
            if (img) {
                if (variant.featured_image) {
                    img.src = typeof variant.featured_image === 'string'
                        ? variant.featured_image
                        : (variant.featured_image.src || '');
                } else if (window.__StickyCartBarMainImage) {
                    img.src = window.__StickyCartBarMainImage;
                }
            }
            
            // 更新价格
            var priceBox = stickyBar.querySelector('.sticky-cart-bar__desktop .product-info .product-price');
            if (priceBox) {
                var html = '';
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    html += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
                }
                html += '<strong>' + formatMoney(variant.price) + '</strong>';
                priceBox.innerHTML = html;
            }
            
            // 更新桌面端隐藏域
            var atcInputDesktop = stickyBar.querySelector('.sticky-cart-bar__desktop input[name="id"]');
            if (atcInputDesktop) {
                atcInputDesktop.value = variantId;
            }
        });
    }


    // 3. 监听手机端 select
    var selectorMobile = stickyBar.querySelector('.variant-selector-mobile');
    if (selectorMobile) {
        selectorMobile.addEventListener('change', function () {
            var variantId = selectorMobile.value;
            var atcInputMobile = stickyBar.querySelector('.sticky-cart-bar__mobile-bottom input[name="id"]');
            if (atcInputMobile) {
                atcInputMobile.value = variantId;
            }
        });
    }

    // 3. 确保表单能正确提交
    var forms = stickyBar.querySelectorAll('form[data-type="add-to-cart-form"]');
    forms.forEach(function(form) {
        // 确保表单有正确的 action 和 method
        if (!form.action) {
            form.action = '/cart/add';
        }
        if (!form.method) {
            form.method = 'post';
        }
        
        // 监听表单提交
        form.addEventListener('submit', function(e) {
            // 让 product-form-component 处理提交
            // 这里不需要阻止默认行为，因为 product-form-component 会处理
        });
    });

    // 金额格式化辅助函数
    function formatMoney(cents) {
        if (typeof cents === 'string') cents = parseInt(cents, 10);
        return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
});